import React from "react";
import { FaPlus } from "react-icons/fa";
import Button from "./Button";

/**
 * NewItemButton
 * - Responsive button with plus icon for creating new items
 * - Shows full text on wide screens, shortened text on mobile
 * - Used in list views (Projects, Users, etc.)
 *
 * Props:
 * - onClick: Function to call when button is clicked
 * - label: Full label text (e.g., "New project", "New user")
 * - shortLabel: Short label for mobile (defaults to "New")
 * - variant: Button variant (defaults to Button default)
 * - size: Button size (defaults to Button default)
 * - show: Boolean to conditionally show button (defaults to true)
 */
const NewItemButton = ({
  onClick,
  label,
  shortLabel = "New",
  variant,
  size,
  show = true,
  ...props
}) => {
  if (!show) return null;

  return (
    <Button onClick={onClick} variant={variant} size={size} {...props}>
      <span className="flex items-center gap-2">
        <FaPlus className="w-4 h-4" />
        <span className="hidden md:inline">{label}</span>
        <span className="md:hidden">{shortLabel}</span>
      </span>
    </Button>
  );
};

export default NewItemButton;
